/* Terraloo Sleek — cart page quantity/remove (full-page reload after change) */
(function () {
  'use strict';

  function changeLine(key, quantity) {
    document.body.style.cursor = 'wait';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        document.body.style.cursor = '';
      });
  }

  document.addEventListener('click', function (e) {
    var stepper = e.target.closest('[data-tls-cart-page-qty-step]');
    if (stepper) {
      var wrap = stepper.closest('[data-tls-cart-page-line-item]');
      var input = wrap && wrap.querySelector('[data-tls-qty-input]');
      if (!input) return;
      var step = parseInt(stepper.getAttribute('data-tls-cart-page-qty-step'), 10);
      var next = Math.max(0, parseInt(input.value, 10) + step);
      changeLine(wrap.getAttribute('data-tls-cart-page-line-item'), next);
    }

    var remove = e.target.closest('[data-tls-cart-page-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-tls-cart-page-remove'), 0);
    }
  });
})();
